import type {CommonProps} from './types';

export default ({color = 'currentColor', size = 24, ...rest}: CommonProps) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 21 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g
      stroke={color}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6.5 10.503l4-4 4 4" />
      <path d="M10.5 6.503v10" />
      <path d="M20.5 17.003l-10 5.5-10-5.5v-11l10-5.5 10 5.5z" />
    </g>
  </svg>
);
